import * as React from 'react';
import { InlineLoading, OverlayLoading } from "../common/index";
interface ISubControlLayoutProps {
  loading?: boolean;
  saving?: boolean;
}
class SubControlLayout extends React.PureComponent<ISubControlLayoutProps, any> {
  constructor(props) {
    super(props);
  }
  componentWillMount() {}
  componentWillReceiveProps(nextProps: any) {}
  componentDidUpdate(prevProps: any) {}
  componentWillUpdate(nextProps: any) {}
  componentWillUnmount() {}
  render() {
    const {
      loading,
      saving
    } = this.props;
    return <div className="container bg-white py-3 box-shadow-x" style={{
      minHeight: "300px",
      position: loading ? "relative" : undefined,
      marginTop: '10px',
      marginBottom: '10px'
    }} data-sentry-component="SubControlLayout" data-sentry-source-file="SubControlLayout.tsx">
            {loading ? <InlineLoading absoluteCenter={true} size={40} /> : <div>
                        {saving ? <OverlayLoading size={40} /> : null}
                        {this.props.children}
                    </div>}
        </div>;
  }
}
export default SubControlLayout;